import * as MockGames from "assets/Desktop/images/mockImageGame";
import { ImageBoardGamePF } from "assets/Mobile/images/games";
import { ImageIA, ImageTF } from "assets/Mobile/images/games/ESport";
import {
  ImageCQ9FH,
  ImageJDBFH,
  ImageJokerFH,
} from "assets/Mobile/images/games/Fishing";
import {
  ImageDG,
  ImageEVO,
  ImagePPLC,
  ImageSexy,
  ImageWM,
} from "assets/Mobile/images/games/LC";
import {
  ImageBoardGame_1,
  ImageBoardGame_aviatrix,
} from "assets/Mobile/images/games/Lottery";
import {
  ImageBNG,
  ImageBTG,
  ImageCQ9,
  ImageFC,
  ImageHabanero,
  ImageIbex,
  ImageJDB,
  ImageJoker,
  ImageKA,
  ImageNLM,
  ImageNT,
  ImagePP,
  ImageRSG,
  ImageRT,
  ImageSPADE,
  ImageSpribe,
} from "assets/Mobile/images/games/Slot";
import { ImageSBO, ImageUG } from "assets/Mobile/images/games/Sport";
import { GameType } from "pages/Mobile/HomePage/GameCategory";
import { SubGameType } from "types/game";

export const LIST_SUB_GAME_DEMO: SubGameType[] = [
  {
    picture: MockGames.MockRT_1,
    game_code: "DEMO_1",
    name: "Wild Fortune",
    provider_code: "DEMO",
    provider_name: "Demo Provider",
    type: "SL",
    featured: "1",
    new_arrive: "1",
  },
  {
    picture: MockGames.MockRT_2,
    game_code: "DEMO_2",
    name: "Dragon Treasure",
    provider_code: "DEMO",
    provider_name: "Demo Provider",
    type: "SL",
    featured: "1",
    new_arrive: "0",
  },
  {
    picture: MockGames.MockImg_1,
    game_code: "DEMO_3",
    name: "Golden Aztec",
    provider_code: "DEMO",
    provider_name: "Demo Provider",
    type: "SL",
    featured: "0",
    new_arrive: "1",
  },
];

export const LIST_HOT_SUB_GAMES: SubGameType[] = [
  {
    game_code: "PP_HOT_01",
    name: "Gates of Olympus",
    provider_code: "PP",
    provider_name: "Pragmatic Play",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockImg_vswayspowzeus,
  },
  {
    game_code: "IBEX_HOT_01",
    name: "Wild Hunt Showdown",
    provider_code: "IBEX",
    provider_name: "IBEX",
    type: "SL",
    featured: "1",
    new_arrive: "1",
    picture: MockGames.MockIbex_1,
  },
  {
    game_code: "BL_HOT_01",
    name: "Bole Sichuan Mahjong - Bloody Fight",
    provider_code: "BL",
    provider_name: "Bole",
    type: "CB",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockBL_1,
  },
  {
    game_code: "PP_HOT_02",
    name: "The Dog House Megaways",
    provider_code: "PP",
    provider_name: "Pragmatic Play",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockImg_vswaysdogs,
  },
  {
    game_code: "IBEX_HOT_02",
    name: "Jurassic World",
    provider_code: "IBEX",
    provider_name: "IBEX",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockIbex_2,
  },
  {
    game_code: "BL_HOT_02",
    name: "Bole Niu-Niu",
    provider_code: "BL",
    provider_name: "Bole",
    type: "CB",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockBL_2,
  },
  {
    game_code: "PP_HOT_03",
    name: "5 Lions Megaways",
    provider_code: "PP",
    provider_name: "Pragmatic Play",
    type: "SL",
    featured: "1",
    new_arrive: "1",
    picture: MockGames.MockImg_vswayslions,
  },
  {
    game_code: "IBEX_HOT_03",
    name: "Bikini Pirate",
    provider_code: "IBEX",
    provider_name: "IBEX",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockIbex_3,
  },
  {
    game_code: "EVO_HOT_01",
    name: "Lightning Roulette",
    provider_code: "EVO",
    provider_name: "Evolution",
    type: "LC",
    featured: "1",
    new_arrive: "1",
    picture: MockGames.MockOver_10,
  },
  {
    game_code: "BNG_HOT_01",
    name: "Magic Apple",
    provider_code: "BNG",
    provider_name: "Booongo",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockBng_MagicApple,
  },
  {
    game_code: "BL_HOT_03",
    name: "Bole Golden Flower",
    provider_code: "BL",
    provider_name: "Bole",
    type: "CB",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockBL_3,
  },
  {
    game_code: "JK_HOT_01",
    name: "Fish Hunter",
    provider_code: "JK",
    provider_name: "Joker Fishing",
    type: "FH",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockFish_3,
  },
  {
    game_code: "SG_HOT_01",
    name: "Jump High",
    provider_code: "SG",
    provider_name: "Spadegaming",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockImg_SGJump,
  },
  {
    game_code: "IBEX_HOT_04",
    name: "Fortune Tiger",
    provider_code: "IBEX",
    provider_name: "IBEX",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockIbex_FortuneTiger,
  },
  {
    game_code: "BL_HOT_04",
    name: "Black Jack",
    provider_code: "BL",
    provider_name: "Bole",
    type: "CB",
    featured: "1",
    new_arrive: "1",
    picture: MockGames.MockBL_8,
  },
  {
    game_code: "EVO_HOT_02",
    name: "Crazy Time",
    provider_code: "EVO",
    provider_name: "Evolution",
    type: "LC",
    featured: "1",
    new_arrive: "1",
    picture: MockGames.MockOver_12,
  },
  {
    game_code: "BNG_HOT_02",
    name: "3 China Pots",
    provider_code: "BNG",
    provider_name: "Booongo",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockBng_3China,
  },
  {
    game_code: "SG_HOT_02",
    name: "Wild Trucks",
    provider_code: "SG",
    provider_name: "Spadegaming",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockImg_SGWildTrucks,
  },
  {
    game_code: "JDB_HOT_01",
    name: "Lucky Fishing",
    provider_code: "JDB",
    provider_name: "JDB Fishing",
    type: "FH",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockFish_5,
  },
  {
    game_code: "CQ9_HOT_01",
    name: "Cai Shen Fishing",
    provider_code: "CQ9",
    provider_name: "CQ9 Fishing",
    type: "FH",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockFish_Caishen,
  },
  {
    game_code: "JDB_HOT_02",
    name: "Fishing Yilufa",
    provider_code: "JDB",
    provider_name: "JDB Fishing",
    type: "FH",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockFish_Yilufa,
  },
  {
    game_code: "JK_HOT_02",
    name: "5 Dragons Fishing",
    provider_code: "JK",
    provider_name: "Joker Fishing",
    type: "FH",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockFish_FiveDragon,
  },
  {
    game_code: "PP_HOT_04",
    name: "Gods of War",
    provider_code: "PP",
    provider_name: "Pragmatic Play",
    type: "SL",
    featured: "1",
    new_arrive: "0",
    picture: MockGames.MockImg_vs15godsofwar,
  },
];

const createProviderGames = (
  providerCode: string,
  providerName: string,
  gameType: string,
  pictures: string | string[],
  gameNames: string[]
): SubGameType[] => {
  const picList = Array.isArray(pictures) ? pictures : [pictures];
  return gameNames.map((name, idx) => ({
    game_code: `${providerCode}_${idx + 1}`,
    name,
    provider_code: providerCode,
    provider_name: providerName,
    type: gameType,
    featured: idx < 4 ? "1" : "0",
    new_arrive: idx % 2 === 0 ? "1" : "0",
    picture: picList[idx % picList.length],
  }));
};

export const PROVIDER_SUB_GAMES: Record<string, SubGameType[]> = {
  // --- IBEX ---
  IBEX: createProviderGames(
    "IBEX",
    "IBEX",
    "SL",
    [
      MockGames.MockIbex_1,
      MockGames.MockIbex_2,
      MockGames.MockIbex_3,
      MockGames.MockIbex_4,
      MockGames.MockIbex_5,
      MockGames.MockIbex_6,
      MockGames.MockIbex_Aztec,
      MockGames.MockIbex_FortuneTiger,
      MockGames.MockIbex_Madness,
      MockGames.MockIbex_5,
      MockGames.MockIbex_2,
      MockGames.MockIbex_3,
    ],
    [
      "Wild Hunt Showdown",
      "Jurassic World",
      "Bikini Pirate",
      "Viking Rising",
      "Sam Phan Nam",
      "Golden Aztec",
      "Aztec Treasure",
      "Fortune Tiger",
      "Madness Slot",
      "Dragon Phoenix",
      "Shadow Hunter",
      "Phantom Dragon",
    ]
  ),

  // --- RED TIGER ---
  RT: createProviderGames(
    "RT",
    "Red Tiger",
    "SL",
    [
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockRT_3,
      MockGames.MockRT_4,
      MockGames.MockRT_5,
      MockGames.MockRT_6,
    ],
    [
      "Santa Spins",
      "Sea Boat Adventure",
      "10,001 Nights Megaways",
      "Shadow Society",
      "10001 Nights",
      "Shah",
      "Dragon's Luck",
      "Piggy Riches Megaways",
      "Gonzo's Quest Megaways",
      "Dynamite Riches",
      "Primate King",
      "Mystery Reels",
    ]
  ),

  // --- PRAGMATIC PLAY ---
  PP: createProviderGames(
    "PP",
    "Pragmatic Play",
    "SL",
    [
      MockGames.MockImg_vs15godsofwar,
      MockGames.MockImg_vswaysdogs,
      MockGames.MockImg_vswayslions,
      MockGames.MockImg_vswayspowzeus,
      MockGames.MockImg_1,
      MockGames.MockImg_2,
      MockGames.MockImg_3,
      MockGames.MockRT_1,
    ],
    [
      "Gates of Olympus",
      "Sweet Bonanza",
      "Sugar Rush",
      "Starlight Princess",
      "Big Bass Bonanza",
      "The Dog House",
      "Power of Thor Megaways",
      "5 Lions Megaways",
      "Gods of War",
      "Madame Destiny",
      "Fruit Party 2",
      "Wild West Gold",
    ]
  ),

  // --- HABANERO ---
  HB: createProviderGames(
    "HB",
    "Habanero",
    "SL",
    [
      MockGames.MockImg_SGMagicOak,
      MockGames.MockImg_SGNuwa,
      MockGames.MockImg_SGWildTrucks,
      MockGames.MockImg_2,
      MockGames.MockImg_3,
      MockGames.MockImg_1,
      MockGames.MockRT_4,
      MockGames.MockRT_5,
      MockGames.MockRT_6,
    ],
    [
      "Hot Hot Fruit",
      "Mystic Fortune Deluxe",
      "Taiko Beats",
      "Koi Gate",
      "Lucky Durian",
      "Lantern Luck",
      "Nuwa",
      "Magic Oak",
      "Wild Trucks",
      "Fa Cai Shen Deluxe",
      "Four Divine Beasts",
      "Jump!",
    ]
  ),
  HABANERO: createProviderGames(
    "HABANERO",
    "Habanero",
    "SL",
    [
      MockGames.MockImg_SGMagicOak,
      MockGames.MockImg_SGNuwa,
      MockGames.MockImg_SGWildTrucks,
      MockGames.MockImg_2,
      MockGames.MockImg_3,
      MockGames.MockImg_1,
      MockGames.MockRT_4,
      MockGames.MockRT_5,
      MockGames.MockRT_6,
    ],
    [
      "Hot Hot Fruit",
      "Mystic Fortune Deluxe",
      "Taiko Beats",
      "Koi Gate",
      "Lucky Durian",
      "Lantern Luck",
      "Nuwa",
      "Magic Oak",
      "Wild Trucks",
      "Fa Cai Shen Deluxe",
      "Four Divine Beasts",
      "Jump!",
    ]
  ),

  // --- BOOONGO ---
  BNG: createProviderGames(
    "BNG",
    "Booongo",
    "SL",
    [
      MockGames.MockBng_3China,
      MockGames.MockBng_MagicApple,
      MockGames.MockRT_3,
      MockGames.MockRT_4,
      MockGames.MockImg_1,
      MockGames.MockImg_2,
    ],
    [
      "Sun of Egypt 3",
      "Magic Apple",
      "Hit the Gold",
      "Tiger Jungle",
      "Black Wolf",
      "15 Dragon Pearls",
      "3 China Pots",
      "Sun of Egypt 2",
      "Scarab Temple",
      "Great Panda",
      "Aztec Sun",
      "Dragon Pearls",
    ]
  ),

  // --- JDB ---
  JDB: createProviderGames(
    "JDB",
    "JDB Gaming",
    "SL",
    [
      MockGames.MockImg_22016,
      MockGames.MockImg_22058,
      MockGames.MockImg_3,
      MockGames.MockRT_5,
      MockGames.MockImg_1,
      MockGames.MockRT_6,
    ],
    [
      "Birds Party",
      "Blossom of Wealth",
      "Dragon King",
      "Lucky Dragons",
      "Fortune Treasure",
      "Winning Mask",
      "Kong",
      "Open Sesame",
      "Guan Gong",
      "Super Niubi Deluxe",
      "Moneybags Man",
      "Caishen Coming",
    ]
  ),

  // --- KA GAMING ---
  KA: createProviderGames(
    "KA",
    "KA Gaming",
    "SL",
    [
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockImg_1,
      MockGames.MockRT_3,
      MockGames.MockImg_2,
      MockGames.MockImg_3,
    ],
    [
      "Cocorico",
      "Bonus Mania",
      "Golden Bull",
      "Mythological",
      "Secret of Ocean",
      "Samurai",
      "Zombie Land",
      "Three Kingdoms",
      "Panda Family",
      "Treasure Bowl",
      "Vampire's Tale",
      "Grand Prix",
    ]
  ),

  // --- FA CHAI ---
  FC: createProviderGames(
    "FC",
    "FaChai Gaming",
    "SL",
    [
      MockGames.MockRT_4,
      MockGames.MockRT_5,
      MockGames.MockImg_2,
      MockGames.MockRT_6,
      MockGames.MockImg_3,
      MockGames.MockImg_1,
    ],
    [
      "Fa Chai Shen",
      "Chinese New Year",
      "Fortune Koi",
      "Money Tree",
      "Golden Lotus",
      "Rich Man",
      "Panda Fortune",
      "Lucky Fortunes",
      "Night Market",
      "Cowboys",
      "Bao Boon Chin",
      "Star Hunter",
    ]
  ),

  // --- ROYAL SLOT GAMING ---
  RSG: createProviderGames(
    "RSG",
    "Royal Slot Gaming",
    "SL",
    [
      MockGames.MockRT_5,
      MockGames.MockRT_6,
      MockGames.MockImg_3,
      MockGames.MockRT_1,
      MockGames.MockImg_2,
      MockGames.MockRT_2,
    ],
    [
      "Fortune Pig",
      "Lucky Miner",
      "Golden Dragon",
      "Mahjong Ways RSG",
      "Rich Mahjong",
      "Aztec Gold",
      "Aladdin",
      "Crazy Nuoza",
      "Taichi",
      "Thor",
      "Pirate King",
      "Roma X",
    ]
  ),

  // --- SPRIBE ---
  SPRI: createProviderGames(
    "SPRI",
    "Spribe",
    "SL",
    [
      MockGames.MockImg_1,
      MockGames.MockImg_2,
      MockGames.MockImg_3,
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockRT_3,
    ],
    [
      "Aviator",
      "Mines",
      "Dice",
      "Plinko",
      "Hilo",
      "Keno",
      "Goal",
      "HotLine",
      "Mini Roulette",
      "Turbo Plinko",
      "Balloon",
      "CricketX",
    ]
  ),

  // --- NETENT ---
  NE: createProviderGames(
    "NE",
    "NetEnt",
    "SL",
    [
      MockGames.MockRT_3,
      MockGames.MockRT_4,
      MockGames.MockImg_1,
      MockGames.MockRT_5,
      MockGames.MockRT_6,
      MockGames.MockImg_2,
    ],
    [
      "Starburst",
      "Dead or Alive II",
      "Twin Spin",
      "Gonzo's Quest",
      "Fruit Shop",
      "Divine Fortune",
      "Dazzle Me",
      "Jack and the Beanstalk",
      "Blood Suckers",
      "Aloha! Cluster Pays",
      "Mega Fortune",
      "Vikings",
    ]
  ),
  NETENT: createProviderGames(
    "NETENT",
    "NetEnt",
    "SL",
    [
      MockGames.MockRT_3,
      MockGames.MockRT_4,
      MockGames.MockImg_1,
      MockGames.MockRT_5,
      MockGames.MockRT_6,
      MockGames.MockImg_2,
    ],
    [
      "Starburst",
      "Dead or Alive II",
      "Twin Spin",
      "Gonzo's Quest",
      "Fruit Shop",
      "Divine Fortune",
      "Dazzle Me",
      "Jack and the Beanstalk",
      "Blood Suckers",
      "Aloha! Cluster Pays",
      "Mega Fortune",
      "Vikings",
    ]
  ),

  // --- NOLIMIT CITY ---
  NLC: createProviderGames(
    "NLC",
    "Nolimit City",
    "SL",
    [
      MockGames.MockRT_5,
      MockGames.MockRT_6,
      MockGames.MockImg_3,
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockImg_1,
    ],
    [
      "San Quentin xWays",
      "Tombstone RIP",
      "Fire in the Hole",
      "Mental",
      "East Coast vs West Coast",
      "Punk Rocker",
      "Deadwood",
      "Das xBoot",
      "El Paso Gunfight",
      "Book of Shadows",
      "True Grit Redemption",
      "Folsom Prison",
    ]
  ),
  NLM: createProviderGames(
    "NLM",
    "Nolimit City",
    "SL",
    [
      MockGames.MockRT_5,
      MockGames.MockRT_6,
      MockGames.MockImg_3,
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockImg_1,
    ],
    [
      "San Quentin xWays",
      "Tombstone RIP",
      "Fire in the Hole",
      "Mental",
      "East Coast vs West Coast",
      "Punk Rocker",
      "Deadwood",
      "Das xBoot",
      "El Paso Gunfight",
      "Book of Shadows",
      "True Grit Redemption",
      "Folsom Prison",
    ]
  ),

  // --- BIG TIME GAMING ---
  BTG: createProviderGames(
    "BTG",
    "Big Time Gaming",
    "SL",
    [
      MockGames.MockImg_2,
      MockGames.MockRT_1,
      MockGames.MockRT_2,
      MockGames.MockImg_3,
      MockGames.MockRT_3,
      MockGames.MockRT_4,
    ],
    [
      "Bonanza Megaways",
      "Extra Chilli",
      "White Rabbit",
      "Danger High Voltage",
      "Who Wants to Be a Millionaire",
      "Holy Diver",
      "Apollo Pays",
      "Chocolates",
      "Donuts",
      "Lil Devil",
      "Kingmaker",
      "Cyberslot Megaclusters",
    ]
  ),

  // --- SPADEGAMING ---
  SG: createProviderGames(
    "SG",
    "Spadegaming",
    "SL",
    [
      MockGames.MockImg_SGJump,
      MockGames.MockRT_2,
      MockGames.MockRT_4,
      MockGames.MockImg_1,
      MockGames.MockRT_5,
      MockGames.MockRT_3,
    ],
    [
      "Fiery Sevens",
      "Heroes",
      "Golden Monkey",
      "Double Flame",
      "Brothers Kingdom",
      "Fishing God",
      "Cai Shen 888",
      "Dragon Empire",
      "Mega 7",
      "Lucky Koi",
      "Three Lucky Stars",
      "Gold Panther",
    ]
  ),
  SPADE: createProviderGames(
    "SPADE",
    "Spadegaming",
    "SL",
    [
      MockGames.MockImg_SGJump,
      MockGames.MockRT_2,
      MockGames.MockRT_4,
      MockGames.MockImg_1,
      MockGames.MockRT_5,
      MockGames.MockRT_3,
    ],
    [
      "Fiery Sevens",
      "Heroes",
      "Golden Monkey",
      "Double Flame",
      "Brothers Kingdom",
      "Fishing God",
      "Cai Shen 888",
      "Dragon Empire",
      "Mega 7",
      "Lucky Koi",
      "Three Lucky Stars",
      "Gold Panther",
    ]
  ),

  // --- JOKER ---
  JK: createProviderGames(
    "JK",
    "Joker",
    "SL",
    [
      MockGames.MockRT_2,
      MockGames.MockRT_5,
      MockGames.MockImg_2,
      MockGames.MockRT_6,
      MockGames.MockRT_1,
      MockGames.MockImg_1,
    ],
    [
      "Roma",
      "Horus Eye",
      "Supreme Caishen",
      "Black Beard Legacy",
      "Golden Dragon",
      "Safari Life",
      "Neptune Treasure",
      "Caishen Riches",
      "Chilli Hunter",
      "Four Dragons",
      "Lucky God Progressive",
      "Aladdin",
    ]
  ),
  JOKER: createProviderGames(
    "JOKER",
    "Joker",
    "SL",
    [
      MockGames.MockRT_2,
      MockGames.MockRT_5,
      MockGames.MockImg_2,
      MockGames.MockRT_6,
      MockGames.MockRT_1,
      MockGames.MockImg_1,
    ],
    [
      "Roma",
      "Horus Eye",
      "Supreme Caishen",
      "Black Beard Legacy",
      "Golden Dragon",
      "Safari Life",
      "Neptune Treasure",
      "Caishen Riches",
      "Chilli Hunter",
      "Four Dragons",
      "Lucky God Progressive",
      "Aladdin",
    ]
  ),

  // --- CQ9 ---
  CQ9: createProviderGames(
    "CQ9",
    "CQ9 Gaming",
    "SL",
    [
      MockGames.MockRT_3,
      MockGames.MockRT_1,
      MockGames.MockImg_3,
      MockGames.MockRT_4,
      MockGames.MockRT_6,
      MockGames.MockImg_2,
    ],
    [
      "Jump High",
      "God of War",
      "Good Fortune",
      "Flying Cai Shen",
      "Rave Jump",
      "Disco Night",
      "Gu Gu Gu",
      "Fa Cai Shen",
      "Kronos",
      "Dragon Boat",
      "Thor",
      "Wonderland",
    ]
  ),

  // --- FISHING (FH) ---
  JDB_FH: createProviderGames(
    "JDB",
    "JDB Fishing",
    "FH",
    [
      MockGames.MockFish_3,
      MockGames.MockFish_5,
      MockGames.MockFish_Caishen,
      MockGames.MockFish_Yilufa,
      MockGames.MockFish_FiveDragon,
      MockGames.MockFish_1,
      MockGames.MockFish_2,
    ],
    [
      "Fish Hunter",
      "Lucky Fishing",
      "Cai Shen Fishing",
      "Fishing Yilufa",
      "5 Dragons Fishing",
      "Dragon Master",
      "Paradise Leviathan",
    ]
  ),
  CQ9_FH: createProviderGames(
    "CQ9",
    "CQ9 Fishing",
    "FH",
    [
      MockGames.MockFish_Caishen,
      MockGames.MockFish_Yilufa,
      MockGames.MockFish_FiveDragon,
      MockGames.MockFish_3,
      MockGames.MockFish_5,
      MockGames.MockFish_1,
      MockGames.MockFish_2,
    ],
    [
      "Cai Shen Fishing",
      "Fishing Yilufa",
      "5 Dragons Fishing",
      "Fish Hunter",
      "Lucky Fishing",
      "Dragon Master",
      "Paradise Leviathan",
    ]
  ),
  JK_FH: createProviderGames(
    "JK",
    "Joker Fishing",
    "FH",
    [
      MockGames.MockFish_FiveDragon,
      MockGames.MockFish_3,
      MockGames.MockFish_5,
      MockGames.MockFish_Caishen,
      MockGames.MockFish_Yilufa,
      MockGames.MockFish_1,
      MockGames.MockFish_2,
    ],
    [
      "5 Dragons Fishing",
      "Fish Hunter",
      "Lucky Fishing",
      "Cai Shen Fishing",
      "Fishing Yilufa",
      "Ocean King",
      "Paradise Leviathan",
    ]
  ),
  JOKER_FH: createProviderGames(
    "JK",
    "Joker Fishing",
    "FH",
    [
      MockGames.MockFish_FiveDragon,
      MockGames.MockFish_3,
      MockGames.MockFish_5,
      MockGames.MockFish_Caishen,
      MockGames.MockFish_Yilufa,
      MockGames.MockFish_1,
      MockGames.MockFish_2,
    ],
    [
      "5 Dragons Fishing",
      "Fish Hunter",
      "Lucky Fishing",
      "Cai Shen Fishing",
      "Fishing Yilufa",
      "Ocean King",
      "Paradise Leviathan",
    ]
  ),

  // --- BOARD GAMES (CB / BG) ---
  BL: createProviderGames(
    "BL",
    "Bole",
    "CB",
    [
      MockGames.MockBL_1,
      MockGames.MockBL_3,
      MockGames.MockBL_6,
      MockGames.MockBL_4,
      MockGames.MockBL_2,
      MockGames.MockBL_7,
      MockGames.MockBL_8,
      MockGames.MockBL_1,
      MockGames.MockBL_3,
      MockGames.MockBL_6,
    ],
    [
      "Bole Sichuan Mahjong - Bloody Fight",
      "Bole Niu-Niu",
      "Bole Golden Flower",
      "Bole Sangong",
      "Bole Sichuan Mahjong - River of Blood",
      "Bole International Mahjong",
      "Black Jack",
      "Bole Guangdong Mahjong",
      "Bole Hunan Mahjong",
      "Bole Hangzhou Mahjong",
    ]
  ),
  BOLE: createProviderGames(
    "BL",
    "Bole",
    "CB",
    [
      MockGames.MockBL_1,
      MockGames.MockBL_3,
      MockGames.MockBL_6,
      MockGames.MockBL_4,
      MockGames.MockBL_2,
      MockGames.MockBL_7,
      MockGames.MockBL_8,
      MockGames.MockBL_1,
      MockGames.MockBL_3,
      MockGames.MockBL_6,
    ],
    [
      "Bole Sichuan Mahjong - Bloody Fight",
      "Bole Niu-Niu",
      "Bole Golden Flower",
      "Bole Sangong",
      "Bole Sichuan Mahjong - River of Blood",
      "Bole International Mahjong",
      "Black Jack",
      "Bole Guangdong Mahjong",
      "Bole Hunan Mahjong",
      "Bole Hangzhou Mahjong",
    ]
  ),
  AVIA: createProviderGames(
    "AVIA",
    "Aviatrix",
    "SL",
    [
      MockGames.MockBL_8,
      MockGames.MockBL_1,
      MockGames.MockBL_2,
      MockGames.MockBL_3,
      MockGames.MockBL_4,
      MockGames.MockBL_6,
    ],
    [
      "Aviatrix",
      "Space XY",
      "JetX",
      "Pilot",
      "Crash X",
      "Spaceman",
    ]
  ),
  PF: createProviderGames(
    "PF",
    "Poker Fantasy",
    "CB",
    [
      MockGames.MockBL_7,
      MockGames.MockBL_8,
      MockGames.MockBL_1,
      MockGames.MockBL_2,
      MockGames.MockBL_3,
      MockGames.MockBL_4,
    ],
    [
      "Texas Hold'em",
      "Omaha Poker",
      "Short Deck",
      "Teen Patti",
      "Andar Bahar",
      "Poker Tournament",
    ]
  ),
};

export const LIST_LOBBY_GAME_HARD: {
  [key in GameType]: SubGameType[];
} = {
  HT: LIST_HOT_SUB_GAMES,
  SL: [
    {
      picture: ImageIbex,
      game_code: "IBEX_01",
      name: "IBEX",
      provider_code: "IBEX",
      provider_name: "IBEX",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageRT,
      game_code: "RT_01",
      name: "RED TIGER",
      provider_code: "RT",
      provider_name: "RED TIGER",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageSPADE,
      game_code: "SG_01",
      name: "SPADE GAMING",
      provider_code: "SG",
      provider_name: "SPADE GAMING",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImageSpribe,
      game_code: "SPRI_01",
      name: "SPRIBE",
      provider_code: "SPRI",
      provider_name: "SPRIBE",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageJoker,
      game_code: "JK_01",
      name: "Joker",
      provider_code: "JK",
      provider_name: "Joker",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageBNG,
      game_code: "BNG_01",
      name: "BNG Slot",
      provider_code: "BNG",
      provider_name: "BNG Slot",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImageCQ9,
      game_code: "CQ9_01",
      name: "CQ9",
      provider_code: "CQ9",
      provider_name: "CQ9",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageHabanero,
      game_code: "HB_01",
      name: "Habanero",
      provider_code: "HB",
      provider_name: "Habanero",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImageJDB,
      game_code: "JDB_01",
      name: "JDB",
      provider_code: "JDB",
      provider_name: "JDB",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageKA,
      game_code: "KA_01",
      name: "KA",
      provider_code: "KA",
      provider_name: "KA",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImagePP,
      game_code: "PP_01",
      name: "Pragmatic Play",
      provider_code: "PP",
      provider_name: "Pragmatic Play",
      type: "SL",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageRSG,
      game_code: "RSG_01",
      name: "RSG",
      provider_code: "RSG",
      provider_name: "RSG",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImageFC,
      game_code: "FC_01",
      name: "Fa Chai Gaming",
      provider_code: "FC",
      provider_name: "Fa Chai Gaming",
      type: "SL",
      featured: "0",
      new_arrive: "1",
    },
  ],
  FH: [
    {
      picture: ImageJDBFH,
      game_code: "JDB_FH_01",
      name: "JDB Fishing",
      provider_code: "JDB",
      provider_name: "JDB Fishing",
      type: "FH",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageCQ9FH,
      game_code: "CQ9_FH_01",
      name: "CQ9 Fishing",
      provider_code: "CQ9",
      provider_name: "CQ9 Fishing",
      type: "FH",
      featured: "0",
      new_arrive: "1",
    },
    {
      picture: ImageJokerFH,
      game_code: "JK_FH_01",
      name: "Joker Fishing",
      provider_code: "JK",
      provider_name: "Joker Fishing",
      type: "FH",
      featured: "1",
      new_arrive: "0",
    },
  ],
  LC: [
    {
      picture: ImageDG,
      game_code: "DG_01",
      name: "Dream Gaming",
      provider_code: "DG",
      provider_name: "Dream Gaming",
      type: "LC",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageEVO,
      game_code: "EVO_01",
      name: "Evolution",
      provider_code: "EVO",
      provider_name: "Evolution",
      type: "LC",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImagePPLC,
      game_code: "PPLC_01",
      name: "Pragmatic Play",
      provider_code: "PPLC",
      provider_name: "Pragmatic Play",
      type: "LC",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageSexy,
      game_code: "SX_01",
      name: "Sexy",
      provider_code: "SX",
      provider_name: "Sexy",
      type: "LC",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageWM,
      game_code: "WM_01",
      name: "WM",
      provider_code: "WM",
      provider_name: "WM",
      type: "LC",
      featured: "0",
      new_arrive: "1",
    },
  ],
  SB: [
    {
      picture: ImageSBO,
      game_code: "SBO_01",
      name: "SBO",
      provider_code: "SBO",
      provider_name: "SBO",
      type: "SB",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageUG,
      game_code: "UG_01",
      name: "UG",
      provider_code: "UG",
      provider_name: "UG",
      type: "SB",
      featured: "1",
      new_arrive: "0",
    },
  ],
  ES: [
    {
      picture: ImageTF,
      game_code: "TF_01",
      name: "TF",
      provider_code: "TF",
      provider_name: "TF",
      type: "ES",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageIA,
      game_code: "IA_01",
      name: "IA",
      provider_code: "IA",
      provider_name: "IA",
      type: "ES",
      featured: "1",
      new_arrive: "0",
    },
  ],
  BG: [
    {
      picture: ImageBoardGame_1,
      game_code: "BL_01",
      name: "Bole",
      provider_code: "BL",
      provider_name: "Bole",
      type: "BG",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageBoardGame_aviatrix,
      game_code: "AVIA_01",
      name: "Aviatrix",
      provider_code: "AVIA",
      provider_name: "Aviatrix",
      type: "BG",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageBoardGamePF,
      game_code: "PF_01",
      name: "Poker Fantasy",
      provider_code: "PF",
      provider_name: "Poker Fantasy",
      type: "BG",
      featured: "1",
      new_arrive: "0",
    },
  ],
  CB: [
    {
      picture: ImageBoardGame_1,
      game_code: "BL_01",
      name: "Bole",
      provider_code: "BL",
      provider_name: "Bole",
      type: "CB",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageBoardGame_aviatrix,
      game_code: "AVIA_01",
      name: "Aviatrix",
      provider_code: "AVIA",
      provider_name: "Aviatrix",
      type: "CB",
      featured: "1",
      new_arrive: "0",
    },
    {
      picture: ImageBoardGamePF,
      game_code: "PF_01",
      name: "Poker Fantasy",
      provider_code: "PF",
      provider_name: "Poker Fantasy",
      type: "CB",
      featured: "1",
      new_arrive: "0",
    },
  ],
  LOTT: [
    {
      picture: ImageBoardGame_1,
      game_code: "LT_01",
      name: "VR",
      provider_code: "VR",
      provider_name: "VR",
      type: "LOTT",
      featured: "1",
      new_arrive: "0",
    },
  ],
};
